import React from "react";
import { Navigation } from "react-minimal-side-navigation";
import { RedeemPolicyTable } from "./RedeemPolicyTable";
import { RewardPolicyTable } from "./RewardPolicyTable";
import { withTranslation } from "react-i18next";

class LoyaltyPointsManagementSettingsClass extends React.Component {
  state = {
    currentMenu: "/",
    isMounted: true,
  };

  componentWillUnmount() {
    this.state.isMounted = false;
  }

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  handleMenuChange = (itemId) => {
    this.updateState({
      currentMenu: itemId,
    });
  };

  render() {
    let { currentMenu } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="customer-list container-fluid mt-4 ">
          <h3 className="head-label mb-4">{t("Loyalty Program")}</h3>
          <div className="row">
            <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2 mb-5 mb-5">
              <Navigation
                activeItemId="/"
                onSelect={({ itemId }) => this.handleMenuChange(itemId)}
                items={[
                  {
                    title: "Reward Policy",
                    itemId: "/",
                  },
                  {
                    title: "Redeem Policy",
                    itemId: "/redeem",
                  },
                ]}
              />
            </div>
            <div className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-10">
              {currentMenu == "/" ? (
                <RewardPolicyTable history={this.props.history} />
              ) : (
                <RedeemPolicyTable history={this.props.history} />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
export const LoyaltyPointsManagementSettings = withTranslation()(
  LoyaltyPointsManagementSettingsClass
);
